"use strict";

document.addEventListener("DOMContentLoaded", () => {
    var recentlyViewed = {};

    (function () {
        var $this;
  
        recentlyViewed = {
            productHandle : null,
            rvCookie: null,
            rvProducts: [],
            displayProducts: [],
            rvProductArray: [],

            /*
			 * Initialize
			 */
			init: function () {

                $this = recentlyViewed;

                const productSection = document.querySelector(".js-product_section[data-rv-handle]");
                const rvProductSection = document.querySelector(".recently-viewed__section"); 
                if (productSection) {
                    $this.productHandle = productSection.dataset.rvHandle.toString();
                    $this.rvCookie = $this.getCookie("recentlyViewed");
                    $this.rvProducts = $this.getCookieProducts($this.rvCookie, $this.productHandle);
                } else if (rvProductSection) {
                    $this.rvCookie = $this.getCookie("recentlyViewed");
                    $this.rvProducts = $this.getCookieProducts($this.rvCookie, $this.productHandle);
                }

                if ($this.rvProducts) {
                    $this.rvProductArray = unescape($this.rvProducts).split(',');
                }

                if ($this.productHandle) {
                    if (!$this.rvProductArray.indexOf($this.productHandle) !== -1) {
                        $this.displayProducts = [];
                        $this.rvProductArray.unshift($this.productHandle);
                        $this.rvProductArray.forEach((el, _i) => {
                            if ($this.displayProducts.indexOf(el) === -1) $this.displayProducts.push(el);
                        });
                    }

                    $this.setCookieProducts($this.displayProducts);
                } else {
                    $this.displayProducts = $this.rvProductArray;
                }
                
                const recentlyViewedSections = document.querySelectorAll(".recently-viewed__section");
                if (recentlyViewedSections.length > 0) {
                    const parent = ".js-recently-viewed";
                    recentlyViewedSections.forEach(el => {
                        
                        if (el.querySelector(".rv-main")) {
                            $this.getProductInformation(el, $this.displayProducts, $this.productHandle);
                        }
                    });
                }
            },

            /*
			 * Get Cookie Products
			 */
            getCookieProducts: function(rvCookie, productHandle) {
                if (!rvCookie && productHandle) {
                    $this.setCookie("recentlyViewed", productHandle, { expires: 30, path: '/', sameSite: 'None', secure: true });
                    rvCookie = $this.getCookie("recentlyViewed");
                } else {
                    rvCookie = $this.getCookie("recentlyViewed");
                }
              
                return rvCookie;
            },

            /*
			 * Set Cookie Products
			 */ 
            setCookieProducts: function(rvProductArray) {
                $this.setCookie("recentlyViewed", escape(rvProductArray.join(',')), { expires: 30, path: '/', sameSite: 'None', secure: true });
            },

            /*
			 * Display Recently Viewed Products
			 */ 
            getProductInformation: function(parent, displayProducts, productHandle) {
                if (parent.dataset.rvLoading === 'true' || parent.dataset.rvReady === 'true') return;

                const productLimit = Number(parent.dataset.visibleProducts || 0);
                const products = Array.isArray(displayProducts) ? displayProducts.filter(Boolean) : [];

                if (productLimit > 0) {
                    products.splice(productLimit);
                }

                if (!products.length) {
                    parent.classList.add("hidden");
                    return;
                }

                parent.dataset.rvLoading = 'true';

                const column = window.outerWidth > 991 ? Number(parent.dataset.column || 4) : 2;
                const requests = products.map((product, index) => {
                    return fetch(`/products/${product}?view=rv`, { credentials: 'same-origin' })
                        .then((response) => {
                            if (!response.ok) throw new Error('Recently viewed product unavailable');
                            return response.text();
                        })
                        .then((htmlText) => {
                            const parsed = new DOMParser().parseFromString(htmlText, "text/html");
                            const rvProductHTML = parsed.querySelector(".js-recently-viewed-product");
                            const targetElement = parent.querySelector(`.rv-box-${index}`);

                            if (!rvProductHTML || !targetElement || !rvProductHTML.innerHTML.trim()) return false;

                            targetElement.innerHTML = rvProductHTML.innerHTML;
                            parent.classList.remove("hidden");

                            if (window.KKMCartQuantityCoordinator?.syncRoot) {
                                window.KKMCartQuantityCoordinator.syncRoot(targetElement).catch(() => {});
                            }

                            return true;
                        })
                        .catch(() => false);
                });

                Promise.all(requests).then((results) => {
                    const insertedCount = results.filter(Boolean).length;

                    parent.querySelectorAll('.grid__item').forEach((gridItem) => {
                        if (gridItem.innerHTML.trim() === "") gridItem.remove();
                    });

                    const arrowBtn = parent.querySelector(".wbhomesbtn");
                    if (arrowBtn) {
                        arrowBtn.classList.toggle("hidden", insertedCount < column);
                    }

                    const recentlyViewer = parent.querySelector('[id^="RecentlyViewer"]');
                    if (recentlyViewer?.resetPages) recentlyViewer.resetPages();

                    if (insertedCount > 0) {
                        parent.classList.remove("hidden");
                        parent.dataset.rvReady = 'true';
                    } else {
                        parent.classList.add("hidden");
                    }
                }).finally(() => {
                    parent.dataset.rvLoading = 'false';
                });
            },

            /*
			 * Set cookie
			 */
			getCookie: function (name) {
				var matches = document.cookie.match(
					new RegExp(
						"(?:^|; )" +
							name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
							"=([^;]*)"
					)
				);
				return matches ? decodeURIComponent(matches[1]) : undefined;
			},

            /*
			 * Set cookie
			 */
			setCookie: function (name, value, options) {
				options = options || {};

				options.path = options.hasOwnProperty("path") ? options.path : "/";

				options.expires = parseInt(options.expires);

				if (typeof options.expires == "number" && options.expires) {
					options.expires = new Date().setDate(
						new Date().getDate() + options.expires
					);

					options.expires = new Date(options.expires).toUTCString();
				}

				value = encodeURIComponent(value);

				var updatedCookie = name + "=" + value;

				for (var propName in options) {
					updatedCookie += "; " + propName;
					var propValue = options[propName];
					if (propValue !== true) {
						updatedCookie += "=" + propValue;
					}
				}

				document.cookie = updatedCookie;
			}
        }

    })();

    // Initialize.
    window.KKMRecentlyViewed = recentlyViewed;
	recentlyViewed.init();

    document.addEventListener('kkm:progressive-section-loaded', (event) => {
        const loadedSection = event.detail?.element;
        if (!loadedSection) return;
        if (loadedSection.matches?.('.recently-viewed__section') || loadedSection.querySelector?.('.recently-viewed__section')) {
            recentlyViewed.init();
        }
    });

    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => {
            recentlyViewed.init();
        });
    }
});